import { Info } from "lucide-react";

export default function UnavailableNodePropertyPanel() {
  return (
    <div className="h-full flex flex-col items-center justify-center p-4 text-center">
      <div className="size-12 flex items-center justify-center rounded-full bg-card">
        <Info className="size-6 text-white" />
      </div>

      <div className="mt-4 text-balance font-medium">
        Propriedades não disponíveis
      </div>

      <div className="mt-1  text-xs text-card-foreground/40 font-medium leading-normal">
        Nenhuma propriedade disponível para este nó ou o nó não está selecionado.
      </div>

      <div className="mt-8 w-full text-xs text-card-foreground/40 font-medium italic">
        Selecione outro nó para visualizar suas propriedades.
      </div>
    </div>
  );
}
